export default "__VITE_ASSET__f170ff0d__"